/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-shape': {
    width: 16,
    height: 16,
    viewBox: '0 0 32.1 44.66',
    data: '<g data-name="Layer 2"><path pid="0" _fill="#fff" d="M16.3 0l15.8 44.66-15.99-10.17L0 44.47 16.3 0z" data-name="Layer 1"/></g>'
  }
})
